import algoliasearch from 'algoliasearch/lite'
import instantsearch from 'instantsearch.js'
import { searchBox, hits, pagination, refinementList, numericMenu, sortBy, rangeInput } from 'instantsearch.js/es/widgets';

import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static targets = [ "searchbox", "hits", "pagination", "pools", "competencies", "tags", "city", "langde", "langen", "zip", "rating", "sortby", "visa", "persontype", "source" ]

    connect() {

        const data = document.getElementById('instantsearch-init').dataset
        const searchClient = algoliasearch(data.applicationId, data.apiKey);
        const talentFinderSearch = instantsearch({
            indexName: data.index,
            searchClient,
            routing: false,
            urlSync: false
        });


        talentFinderSearch.addWidgets([

            sortBy({
                container: this.sortbyTarget,
                items: [
                        { value: 'Applicant_score', label: 'Punktzahl' },
                        { value: 'Applicant_lastname_asc', label: 'Nachname aufsteigend' },
                        { value: 'Applicant_lastname_desc', label: 'Nachname absteigend' }
                    ],
                defaultRefinement: 'Applicant_score',}),

            searchBox({
                container: this.searchboxTarget,
                cssClasses: {
                    input: 'pl-8',
                },
                style: {
                    'padding-left': '3rem'
                }
            }),

            hits({
                container: this.hitsTarget,
                cssClasses: {
                    item: 'relative bg-white shadow-lg rounded-2xl p-6 flex flex-col md:flex-row gap-6 items-center transition-all hover:shadow-2xl mb-6',
                },
                templates: {
                    empty: '<div class="p-4 text-center text-gray-600">Keine Ergebnisse gefunden</div>',
                    item: `<div class="relative bg-white rounded-2xl p-6 flex flex-col md:flex-row gap-6 items-center transition-all">
                  
                  <!-- Prominenter Match Score in der oberen rechten Ecke -->
                  <div class="absolute top-4 right-4 z-10">
                    <div class="flex flex-col items-end gap-1">
                      <div class="flex items-center shadow-lg gap-2 bg-white rounded-lg px-3 py-2" title="Match-Score basierend auf Kompetenzen und Erfahrung">
                        <span class="text-xs text-gray-600">
                          <i class="fas fa-bolt mr-1"></i>
                          Match:
                        </span>
                        <div class="flex items-center gap-1">
                          <div class="w-12 h-2 bg-gray-200 rounded-full overflow-hidden">
                            <div class="h-full rounded-full bg-blue-500" style="width: {{ score }}%"></div>
                          </div>
                          <span class="text-sm font-bold text-blue-600">{{ score }}%</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Avatar/Bild -->
                  <div class="flex-shrink-0">
                    <div class="w-16 h-16 bg-gray-200 rounded-full flex items-center justify-center">
                      <span class="text-2xl font-bold text-gray-600">{{ firstname | first_letter }}{{ lastname | first_letter }}</span>
                    </div>
                  </div>

                  <!-- Hauptinhalt -->
                  <div class="flex-1">
                    <h3 class="text-2xl font-bold mb-1 flex items-center gap-2">
                      {{ firstname }} {{ lastname }}
                      <span class="inline-block bg-blue-50 text-blue-700 text-xs font-semibold px-2 py-1 rounded ml-2">{{ title }}</span>
                      <span class="inline-block bg-purple-50 text-purple-700 text-xs font-semibold px-2 py-1 rounded ml-2">{{ person_type }}</span>
                    </h3>

                    <!-- Kompetenzen -->
                    <div class="flex flex-wrap gap-2 mb-3 mt-2">
                      {{#competencies}}
                      <span class="inline-flex items-center bg-blue-100 text-blue-800 font-semibold px-3 py-1 rounded-full text-xs shadow-sm">
                        {{ title }}
                      </span>
                      {{/competencies}}
                    </div>

                    <!-- Informationen -->
                    <div class="flex gap-4 text-gray-500 text-sm mb-2">
                      <span class="flex items-center">
                        <i class="fas fa-graduation-cap mr-1"></i>
                        {{ academic_title }}
                      </span>
                      <span class="flex items-center">
                        <i class="fas fa-map-marker-alt mr-1"></i>
                        {{ city }}
                      </span>
                      <span class="flex items-center">
                        <i class="fas fa-calendar-check mr-1"></i>
                        Alter: {{ age }}
                      </span>
                      {{#last_activity_date}}
                      <span class="flex items-center">
                        <i class="fas fa-clock mr-1"></i>
                        Aktiv: {{ Date(last_activity_date) }}
                      </span>
                      {{/last_activity_date}}
                    </div>

                    <!-- Pools -->
                    <div class="flex flex-wrap gap-2 mb-2">
                      {{#pools}}
                      <span class="inline-flex items-center bg-gray-100 text-gray-700 font-semibold px-2 py-1 rounded text-xs">
                        {{ title }}
                      </span>
                      {{/pools}}
                    </div>

                    <!-- Tags -->
                    <div class="flex flex-wrap gap-2 mb-2">
                      {{#_tags}}
                      <span class="inline-flex items-center bg-purple-100 text-purple-700 font-semibold px-2 py-1 rounded text-xs">
                        {{ tag }}
                      </span>
                      {{/_tags}}
                    </div>

                    <!-- Info-Tabs -->
                    <div class="mt-4">
                      <!-- Tab Navigation -->
                      <div class="border-b border-gray-200">
                        <nav class="-mb-px flex space-x-8" aria-label="Tabs">
                          <button class="tab-button whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm border-blue-500 text-blue-600" data-tab="summary">
                            Zusammenfassung
                          </button>
                          <button class="tab-button whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" data-tab="history">
                            Einsatzhistorie
                          </button>
                          <button class="tab-button whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" data-tab="additional">
                            Zusatzinfos
                          </button>
                          <button class="tab-button whitespace-nowrap py-2 px-1 border-b-2 font-medium text-sm border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300" data-tab="skills">
                            Kompetenzen & Sprachen
                          </button>
                        </nav>
                      </div>

                      <!-- Tab Panels -->
                      <div class="mt-4">
                        <!-- Zusammenfassung Tab Panel -->
                        <div class="tab-panel active" data-tab="summary">
                          <div class="space-y-6">
                            {{#matching_notes}}
                            <div class="bg-yellow-50 border border-yellow-200 rounded-lg p-2">
                              <h4 class="text-xs font-medium text-yellow-900 mb-2">Matching Notes</h4>
                              <p class="text-yellow-800 text-xs">{{ matching_notes }}</p>
                            </div>
                            {{/matching_notes}}
                            {{#summary}}
                            <div>
                              <div class="bg-white border border-gray-200 rounded-lg p-4">
                                <h4 class="text-sm font-medium text-gray-900 mb-2">Berufliche Zusammenfassung</h4>
                                <p class="text-gray-700 text-sm">{{ summary }}</p>
                              </div>
                            </div>
                            {{/summary}}
                            {{^summary}}
                            {{^matching_notes}}
                            <div class="text-center py-8">
                              <i class="fas fa-info-circle text-gray-400 text-3xl mb-3"></i>
                              <p class="text-gray-500 text-sm">Keine Zusammenfassung verfügbar</p>
                            </div>
                            {{/matching_notes}}
                            {{/summary}}
                          </div>
                        </div>

                        <!-- Einsatzhistorie Tab Panel -->
                        <div class="tab-panel hidden" data-tab="history">
                          <div class="space-y-4">
                            {{#experiences}}
                            <div class="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
                              <div class="flex justify-between items-start mb-3">
                                <h5 class="text-lg font-semibold text-gray-900">{{ title }}</h5>
                                <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-purple-100 text-purple-800">{{ start_date }} - {{ end_date }}</span>
                              </div>
                              <p class="text-sm font-medium text-gray-600 mb-2">{{ company }}</p>
                              <p class="text-sm text-gray-500 leading-relaxed">{{ description }}</p>
                            </div>
                            {{/experiences}}
                            {{^experiences}}
                            <div class="bg-white border border-gray-200 rounded-lg p-8 text-center">
                              <i class="fas fa-inbox text-gray-400 text-3xl mb-3"></i>
                              <p class="text-gray-500 text-sm">Keine Einsatzhistorie verfügbar</p>
                            </div>
                            {{/experiences}}
                          </div>
                        </div>

                        <!-- Zusatzinfos Tab Panel -->
                        <div class="tab-panel hidden" data-tab="additional">
                          <div class="bg-white border border-gray-200 rounded-lg p-6 text-center">
                            <i class="fas fa-info-circle text-orange-400 text-2xl mb-3"></i>
                            <p class="text-gray-500 text-sm">Zusätzliche Informationen wurden in den "Kompetenzen & Sprachen" Tab verschoben</p>
                          </div>
                        </div>

                        <!-- Kompetenzen & Sprachen Tab Panel -->
                        <div class="tab-panel hidden" data-tab="skills">
                          <div class="text-center py-8">
                            <div class="inline-flex items-center px-4 py-2 rounded-full text-sm font-medium bg-blue-100 text-blue-800">
                              <i class="fas fa-spinner fa-spin mr-2"></i>
                              Daten werden geladen...
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Aktions-Buttons -->
                  <div class="flex flex-col items-end gap-2 mt-4">
                    <!-- Favoriten-Button -->
                    <button class="favorite-btn inline-flex items-center justify-center w-full px-4 py-2 font-semibold rounded-lg shadow transition" 
                            data-applicant-id="{{ id }}" 
                            data-followed="{{ followed_by_current_user }}">
                      <i class="far fa-star mr-2 favorite-icon"></i>
                      <span class="favorite-text">Favorit</span>
                    </button>
                    
                    <a href="/backend/applicants/{{ id }}" target="_top" class="inline-flex items-center justify-center w-full px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg shadow hover:bg-blue-700 transition">
                      <i class="fas fa-user mr-2"></i>
                      Ressource ansehen
                    </a>
                    
                    <a href="/backend/profiles/new?applicant_id={{ id }}" target="_top" class="inline-flex items-center justify-center w-full px-4 py-2 bg-green-600 text-white font-semibold rounded-lg shadow hover:bg-green-700 transition">
                      <i class="fas fa-plus mr-2"></i>
                      Profil erstellen
                    </a>
                    
            
                  </div>
                </div>`
                }
            }),

            pagination({
                container: this.paginationTarget
            }),

            refinementList({
                container: this.persontypeTarget,
                attribute: 'person_type',
                operator: 'or',
                showMore: true,
                cssClasses: {
                    count: ['px-1', 'rounded-md', 'text-sm', 'bg-opacity-50', 'bg-purple-600', 'font-normal', 'text-white'],
                    labelText: ['ml-1', 'font-medium']
                },
                templates: {
                    showMoreText: `
                      {{#isShowingMore}}
                        weniger anzeigen
                      {{/isShowingMore}}
                      {{^isShowingMore}}
                        mehr anzeigen
                      {{/isShowingMore}}
                    `
                }

            }),


            refinementList({
                container: this.poolsTarget,
                attribute: 'pools.title',
                operator: 'or',
                showMore: true,
                cssClasses: {
                    count: ['px-1', 'rounded-md', 'text-sm', 'bg-opacity-50', 'bg-purple-600', 'font-normal', 'text-white'],
                    labelText: ['ml-1', 'font-medium']
                },
                templates: {
                    showMoreText: `
                      {{#isShowingMore}}
                        weniger anzeigen
                      {{/isShowingMore}}
                      {{^isShowingMore}}
                        mehr anzeigen
                      {{/isShowingMore}}
                    `
                }

            }),

            refinementList({
                container: this.visaTarget,
                attribute: 'visa_state',
                operator: 'or',
                showMore: true,
                cssClasses: {
                    count: ['px-1', 'rounded-md', 'text-sm', 'bg-opacity-50', 'bg-purple-600', 'font-normal', 'text-white'],
                    labelText: ['ml-1', 'font-medium']
                },
                templates: {
                    showMoreText: `
                      {{#isShowingMore}}
                        weniger anzeigen
                      {{/isShowingMore}}
                      {{^isShowingMore}}
                        mehr anzeigen
                      {{/isShowingMore}}
                    `
                }

            }),

            refinementList({
                container: this.competenciesTarget,
                attribute: 'competencies.title',
                operator: 'and',
                searchable: true,
                searchablePlaceholder: 'Suchen',
                cssClasses: {
                    count: ['px-1', 'rounded-md', 'text-sm', 'bg-opacity-50', 'bg-purple-600', 'font-normal', 'text-white'],
                    labelText: ['ml-1', 'font-medium']
                },
                templates: {
                    showMoreText: `
                      {{#isShowingMore}}
                        weniger anzeigen
                      {{/isShowingMore}}
                      {{^isShowingMore}}
                        mehr anzeigen
                      {{/isShowingMore}}
                    `
                }
            }),

            refinementList({
                container: this.tagsTarget,
                attribute: '_tags',
                searchable: true,
                operator: 'and',
                showMore: true,
                searchablePlaceholder: 'Suchen',
                cssClasses: {
                    count: ['px-1', 'rounded-md', 'text-sm', 'bg-opacity-50', 'bg-purple-600', 'font-normal', 'text-white'],
                    labelText: ['ml-1', 'font-medium']
                },
                templates: {
                    showMoreText: `
                      {{#isShowingMore}}
                        weniger anzeigen
                      {{/isShowingMore}}
                      {{^isShowingMore}}
                        mehr anzeigen
                      {{/isShowingMore}}
                    `
                }
            }),




            numericMenu({
                container: this.langdeTarget,
                attribute: 'lang_de',
                items: [
                    { label: 'Alle' },
                    { label: 'min. A1⭐', start: 1, end: 6 },
                    { label: 'min. A2⭐', start: 2, end: 6 },
                    { label: 'min. B1⭐', start: 3, end: 6 },
                    { label: 'min. B2⭐', start: 4, end: 6 },
                    { label: 'min. C1⭐', start: 5, end: 6 },
                    { label: 'min. C2⭐', start: 6, end: 6 }],
                cssClasses: {
                    labelText: ['ml-1', 'font-medium']
                }
            }),

            numericMenu({
                container: this.langenTarget,
                attribute: 'lang_en',
                items: [
                    { label: 'Alle' },
                    { label: 'min. A1⭐', start: 1, end: 6 },
                    { label: 'min. A2⭐', start: 2, end: 6 },
                    { label: 'min. B1⭐', start: 3, end: 6 },
                    { label: 'min. B2⭐', start: 4, end: 6 },
                    { label: 'min. C1⭐', start: 5, end: 6 },
                    { label: 'min. C2⭐', start: 6, end: 6 }],
                cssClasses: {
                    labelText: ['ml-1', 'font-medium']
                }
            }),

            numericMenu({
                container: this.ratingTarget,
                attribute: 'average_rating_for_search',
                items: [
                    { label: 'Alle' },
                    { label: 'min. 1⭐', start: 1, end: 5 },
                    { label: 'min. 2⭐', start: 2, end: 5 },
                    { label: 'min. 3⭐', start: 3, end: 5 },
                    { label: 'min. 4⭐', start: 4, end: 5 },
                    { label: 'min. 5⭐', start: 5, end: 5 } ],
                cssClasses: {
                    labelText: ['ml-1', 'font-medium']
                }
            }),

            numericMenu({
                container: this.zipTarget,
                attribute: 'zip_numeric',
                items: [
                    { label: 'Alle' },
                    { label: '0..', start: 0, end: 1000 },
                    { label: '1..', start: 1000, end: 1999 },
                    { label: '2..', start: 2000, end: 2999 },
                    { label: '3..', start: 3000, end: 3999 },
                    { label: '4..', start: 4000, end: 4999 },
                    { label: '5..', start: 5000, end: 5999 },
                    { label: '6..', start: 6000, end: 6999 },
                    { label: '7..', start: 7000, end: 7999 },
                    { label: '8..', start: 8000, end: 8999 },
                    { label: '9..', start: 9000, end: 9999 }
                    ],
                cssClasses: {
                    labelText: ['ml-1', 'font-medium']
                }
            }),

            refinementList({
                container: this.sourceTarget,
                attribute: 'source.title',
                searchable: true,
                operator: 'or',
                showMore: true,
                searchablePlaceholder: 'Suchen',
                cssClasses: {
                    count: ['px-1', 'rounded-md', 'text-sm', 'bg-opacity-50', 'bg-purple-600', 'font-normal', 'text-white'],
                    labelText: ['ml-1', 'font-medium']
                },
                templates: {
                    showMoreText: `
                      {{#isShowingMore}}
                        weniger anzeigen
                      {{/isShowingMore}}
                      {{^isShowingMore}}
                        mehr anzeigen
                      {{/isShowingMore}}
                    `
                }
            })


        ]);

        talentFinderSearch.start();

        // Verhindere das Neuladen der Seite bei "show more" Buttons
        this.preventShowMoreReload();

        // Tab-Funktionalität initialisieren
        this.initializeTabs();

        // Suchhilfe-Funktionalität initialisieren
        this.initializeSearchHelp();

        // Favoriten-Funktionalität initialisieren
        this.initializeFavorites();

        // "Mehr anzeigen" Funktionalität initialisieren
        this.initializeShowMore();



    }

    preventShowMoreReload() {
        // Event Listener für alle "show more" Buttons
        const handleShowMoreClick = (event) => {
            event.preventDefault();
            event.stopPropagation();
            return false;
        };

        // Observer für dynamisch hinzugefügte Buttons
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const showMoreButtons = node.querySelectorAll('.ais-RefinementList-showMore');
                        showMoreButtons.forEach(button => {
                            button.removeEventListener('click', handleShowMoreClick);
                            button.addEventListener('click', handleShowMoreClick);
                        });
                    }
                });
            });
        });

        // Beobachte Änderungen im DOM
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        // Initial für bereits vorhandene Buttons
        document.querySelectorAll('.ais-RefinementList-showMore').forEach(button => {
            button.removeEventListener('click', handleShowMoreClick);
            button.addEventListener('click', handleShowMoreClick);
        });
    }

    initializeTabs() {
        // Tab-Funktionalität für alle Karten
        const handleTabClick = (event) => {
            const button = event.target;
            const tabName = button.getAttribute('data-tab');
            const card = button.closest('.ais-Hits-item');
            
            if (!card) return;

            // Lade Daten beim ersten Klick auf einen Tab
            if (tabName === 'history' || tabName === 'skills') {
                this.loadTabData(card);
            }

            // Alle Tabs in dieser Karte deaktivieren
            card.querySelectorAll('.tab-button').forEach(btn => {
                btn.classList.remove('active', 'border-blue-500', 'text-blue-600');
                btn.classList.add('border-transparent', 'text-gray-500');
            });

            // Alle Tab-Inhalte in dieser Karte ausblenden
            card.querySelectorAll('.tab-panel').forEach(content => {
                content.classList.add('hidden');
                content.classList.remove('active');
            });

            // Aktiven Tab aktivieren
            button.classList.add('active', 'border-blue-500', 'text-blue-600');
            button.classList.remove('border-transparent', 'text-gray-500');

            // Aktiven Tab-Inhalt anzeigen
            const activeContent = card.querySelector(`.tab-panel[data-tab="${tabName}"]`);
            if (activeContent) {
                activeContent.classList.remove('hidden');
                activeContent.classList.add('active');
            }
        };

        // Event-Listener für Tab-Buttons hinzufügen
        const addTabListeners = () => {
            document.querySelectorAll('.tab-button').forEach(button => {
                button.removeEventListener('click', handleTabClick);
                button.addEventListener('click', handleTabClick);
            });
        };

        // Initial Event-Listener hinzufügen
        addTabListeners();

        // Observer für neue Karten
        const tabObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const tabButtons = node.querySelectorAll('.tab-button');
                        if (tabButtons.length > 0) {
                            addTabListeners();
                        }
                    }
                });
            });
        });

        // Beobachte Änderungen im Hits-Container
        const hitsContainer = this.hitsTarget;
        if (hitsContainer) {
            tabObserver.observe(hitsContainer, {
                childList: true,
                subtree: true
            });
        }


    }



    loadTabData(card) {
        const applicantId = card.querySelector('[data-applicant-id]')?.getAttribute('data-applicant-id');
        if (!applicantId || card.dataset.tabDataLoaded === 'true') return;

        fetch(`/de/backend/applicants/${applicantId}/tab_data`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
        })
        .then(response => response.json())
        .then(data => {
            if (data.success) {
                this.updateTabContent(card, data);
                card.dataset.tabDataLoaded = 'true';
            } else {
                // Zeige Fehlermeldung im Tab
                const tabContent = card.querySelector('.tab-panel[data-tab="summary"], .tab-panel[data-tab="history"], .tab-panel[data-tab="skills"]');
                if (tabContent) {
                    tabContent.innerHTML = `<div class="text-center py-8"><p class="text-red-500 text-sm">Fehler beim Laden der Daten: ${data.error}</p></div>`;
                }
            }
        })
        .catch(error => {
            // Zeige Fehlermeldung im Tab
            const tabContent = card.querySelector('.tab-panel[data-tab="summary"], .tab-panel[data-tab="history"], .tab-panel[data-tab="skills"]');
            if (tabContent) {
                tabContent.innerHTML = `<div class="text-center py-8"><p class="text-red-500 text-sm">Fehler beim Laden der Daten</p></div>`;
            }
        });
    }

    updateTabContent(card, data) {
        // Einsatzhistorie Tab
        const historyTab = card.querySelector('.tab-panel[data-tab="history"]');
        if (historyTab && data.experiences) {
            let historyHtml = `<div class="space-y-3">`;
            
            if (data.experiences.length > 0) {
                // Sortiere nach Startdatum (neueste zuerst)
                const sortedExperiences = data.experiences.sort((a, b) => {
                    const dateA = new Date(a.start_date);
                    const dateB = new Date(b.start_date);
                    return dateB - dateA;
                });
                
                historyHtml += `
                    <div class="overflow-x-auto">
                        <table class="min-w-full bg-white border border-gray-200 rounded-lg">
                            <thead class="bg-gray-50">
                                <tr>
                                    <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Position</th>
                                    <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Unternehmen</th>
                                    <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Zeitraum</th>
                                    <th class="px-4 py-2 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Beschreibung</th>
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200">
                `;
                
                sortedExperiences.forEach(exp => {
                    historyHtml += `
                        <tr class="hover:bg-gray-50">
                            <td class="px-4 py-2 text-xs font-medium text-gray-900">${exp.title || '-'}</td>
                            <td class="px-4 py-2 text-xs text-gray-600">${exp.company || '-'}</td>
                            <td class="px-4 py-2 text-xs text-gray-600">${exp.start_date || '-'} - ${exp.end_date || 'Aktuell'}</td>
                            <td class="px-4 py-2 text-xs text-gray-500 max-w-xs truncate" title="${exp.description || ''}">${exp.description || '-'}</td>
                        </tr>
                    `;
                });
                
                historyHtml += `
                            </tbody>
                        </table>
                    </div>
                `;
            } else {
                historyHtml = '<p class="text-gray-500 text-sm italic text-center py-8">Keine Einsatzhistorie verfügbar</p>';
            }
            historyHtml += '</div>';
            historyTab.innerHTML = `<div class="text-gray-700 text-sm">${historyHtml}</div>`;
        }



        // Kompetenzen Tab
        const skillsTab = card.querySelector('.tab-panel[data-tab="skills"]');
        if (skillsTab) {
            let skillsHtml = `
                <div class="space-y-6">
                    <!-- Fachkompetenzen -->
                    <div>
                        <div class="bg-gray-50 p-4 rounded-lg">
            `;
            
            if (data.competencies && data.competencies.length > 0) {
                // Kompetenzen nach Punktzahl sortieren (höchste zuerst)
                const sortedCompetencies = data.competencies.sort((a, b) => (b.weight || 0) - (a.weight || 0));
                
                skillsHtml += `<div class="flex flex-wrap gap-2">`;
                sortedCompetencies.forEach(comp => {
                    skillsHtml += `
                        <div class="inline-flex items-center bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
                            <span class="mr-2">${comp.title || 'Unbekannte Kompetenz'}</span>
                            <span class="bg-blue-200 text-blue-900 px-2 py-0.5 rounded-full text-xs font-bold">
                                ${comp.weight || 0}
                            </span>
                        </div>
                    `;
                });
                skillsHtml += `</div>`;
            } else {
                skillsHtml += '<p class="text-gray-500 text-sm italic">Keine Fachkompetenzen verfügbar</p>';
            }
            skillsHtml += '</div></div>';

            // Sprachen
            skillsHtml += `
                <div>
                    <div class="bg-gray-50 p-4 rounded-lg">
            `;
            
            if (data.lang_de) {
                skillsHtml += `
                    <div class="flex items-center justify-between mb-2 p-2 bg-green-50 rounded-lg">
                        <span class="font-medium text-green-900">Deutsch</span>
                        <div class="flex items-center">
                            <div class="w-16 h-2 bg-gray-200 rounded-full mr-2">
                                <div class="h-full rounded-full bg-green-500" style="width: ${data.lang_de * 16.67}%"></div>
                            </div>
                            <span class="text-xs font-bold text-green-600">${data.lang_de}/6</span>
                        </div>
                    </div>
                `;
            }
            
            if (data.lang_en) {
                skillsHtml += `
                    <div class="flex items-center justify-between mb-2 p-2 bg-green-50 rounded-lg">
                        <span class="font-medium text-green-900">Englisch</span>
                        <div class="flex items-center">
                            <div class="w-16 h-2 bg-gray-200 rounded-full mr-2">
                                <div class="h-full rounded-full bg-green-500" style="width: ${data.lang_en * 16.67}%"></div>
                            </div>
                            <span class="text-xs font-bold text-green-600">${data.lang_en}/6</span>
                        </div>
                    </div>
                `;
            }
            
            if (!data.lang_de && !data.lang_en) {
                skillsHtml += '<p class="text-gray-500 text-sm italic">Keine Sprachkenntnisse verfügbar</p>';
            }
            skillsHtml += '</div></div>';

            // Bewertungen
            skillsHtml += `
                <div>
                    <div class="bg-gray-50 p-4 rounded-lg">
            `;
            
            if (data.average_rating) {
                skillsHtml += `
                    <div class="flex items-center justify-between mb-2 p-2 bg-yellow-50 rounded-lg">
                        <span class="font-medium text-yellow-900">Durchschnittsbewertung</span>
                        <div class="flex items-center">
                            <div class="flex items-center mr-2">
                                ${'<i class="fas fa-star text-yellow-500 text-xs"></i>'.repeat(Math.round(data.average_rating))}
                            </div>
                            <span class="text-xs font-bold text-yellow-600">${data.average_rating}/5</span>
                        </div>
                    </div>
                `;
            } else {
                skillsHtml += '<p class="text-gray-500 text-sm italic">Keine Bewertungen verfügbar</p>';
            }
            skillsHtml += '</div></div>';

            skillsHtml += '</div></div>';

            skillsTab.innerHTML = `<div class="text-gray-700 text-sm">${skillsHtml}</div>`;
        }
    }

    initializeSearchHelp() {
        // Suchhilfe Toggle-Funktion
        window.toggleSearchHelp = () => {
            const content = document.getElementById('searchHelpContent');
            const icon = document.getElementById('searchHelpIcon');
            
            if (content.classList.contains('hidden')) {
                content.classList.remove('hidden');
                icon.classList.add('rotate-180');
            } else {
                content.classList.add('hidden');
                icon.classList.remove('rotate-180');
            }
        };
    }

    initializeFavorites() {
        // Favoriten-Funktionalität
        const handleFavoriteClick = (event) => {
            const button = event.target.closest('.favorite-btn');
            if (!button) return;

            const applicantId = button.getAttribute('data-applicant-id');
            
            // Prüfe den aktuellen Follow-Status
            const icon = button.querySelector('.favorite-icon');
            const isFollowed = icon.classList.contains('fas');

            // Button während Request deaktivieren
            button.disabled = true;
            const originalText = button.innerHTML;

            // AJAX Request
            fetch(`/backend/applicants/${applicantId}/toggle_follow`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                    'Accept': 'application/json'
                },
                credentials: 'same-origin'
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                if (data.success) {
                    // Button-Status aktualisieren
                    const icon = button.querySelector('.favorite-icon');
                    const text = button.querySelector('.favorite-text');
                    
                    if (data.followed) {
                        // Jetzt favorisiert
                        button.classList.remove('border-yellow-500', 'text-yellow-600', 'hover:bg-yellow-50');
                        button.classList.add('bg-yellow-500', 'text-white', 'hover:bg-yellow-600');
                        icon.classList.remove('far');
                        icon.classList.add('fas');
                        text.textContent = 'Favorit';
                        button.setAttribute('data-followed', 'true');
                    } else {
                        // Nicht mehr favorisiert
                        button.classList.remove('bg-yellow-500', 'text-white', 'hover:bg-yellow-600');
                        button.classList.add('border-yellow-500', 'text-yellow-600', 'hover:bg-yellow-50');
                        icon.classList.remove('fas');
                        icon.classList.add('far');
                        text.textContent = 'Favorit';
                        button.setAttribute('data-followed', 'false');
                    }
                } else {
                    console.error('Fehler beim Togglen der Favoriten:', data.error);
                    alert('Fehler: ' + (data.error || 'Unbekannter Fehler'));
                }
            })
            .catch(error => {
                console.error('Fehler beim Togglen der Favoriten:', error);
                alert('Fehler beim Aktualisieren der Favoriten. Bitte versuchen Sie es erneut.');
            })
            .finally(() => {
                button.disabled = false;
            });
        };

        // Event-Listener für Favoriten-Buttons hinzufügen
        const addFavoriteListeners = () => {
            document.querySelectorAll('.favorite-btn').forEach(button => {
                button.removeEventListener('click', handleFavoriteClick);
                button.addEventListener('click', handleFavoriteClick);
            });
        };

        // Initial Event-Listener hinzufügen
        addFavoriteListeners();

        // Observer für neue Karten
        const favoriteObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const favoriteButtons = node.querySelectorAll('.favorite-btn');
                        if (favoriteButtons.length > 0) {
                            addFavoriteListeners();
                        }
                    }
                });
            });
        });

        // Beobachte Änderungen im Hits-Container
        const hitsContainer = this.hitsTarget;
        if (hitsContainer) {
            favoriteObserver.observe(hitsContainer, {
                childList: true,
                subtree: true
            });
        }
    }

    initializeShowMore() {
        // "Mehr anzeigen" Funktionalität für zusätzliche Informationen
        const handleShowMoreClick = (event) => {
            const button = event.target;
            const content = button.previousElementSibling;
            
            if (content.classList.contains('max-h-20')) {
                // Expandieren
                content.classList.remove('max-h-20', 'overflow-hidden');
                button.textContent = 'Weniger anzeigen';
            } else {
                // Zusammenklappen
                content.classList.add('max-h-20', 'overflow-hidden');
                button.textContent = 'Mehr anzeigen';
            }
        };

        // Event-Listener für "Mehr anzeigen" Buttons hinzufügen
        const addShowMoreListeners = () => {
            document.querySelectorAll('.show-more-btn').forEach(button => {
                button.removeEventListener('click', handleShowMoreClick);
                button.addEventListener('click', handleShowMoreClick);
            });
        };

        // Initial Event-Listener hinzufügen
        addShowMoreListeners();

        // Observer für neue Karten
        const showMoreObserver = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE) {
                        const showMoreButtons = node.querySelectorAll('.show-more-btn');
                        if (showMoreButtons.length > 0) {
                            addShowMoreListeners();
                        }
                    }
                });
            });
        });

        // Beobachte Änderungen im Hits-Container
        const hitsContainer = this.hitsTarget;
        if (hitsContainer) {
            showMoreObserver.observe(hitsContainer, {
                childList: true,
                subtree: true
            });
        }
    }



}
